export default __webpack_public_path__ + "65496620875287a00f23bde74a07c968.svg";